import {
	deleteHighlight,
	getHighlights,
	highlightByID,
	saveHighlight,
	updateHighlight,
} from '@/services/tv/highlights.service'
export default {
	namespaced: true,
	state: {
		highlightList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		highlightstatus: 'pending',
	},
	getters: {
		getHighlightList(state) {
			return state.highlightList
		},
		getHighlightsStatus(state) {
			return state.highlightstatus
		},
	},
	mutations: {
		SET_HIGHLIGHT_LIST(state, value) {
			state.highlightList = value
		},
		SET_HIGHLIGHT_STATUS(state, value) {
			state.highlightstatus = value
		},
	},
	actions: {
		async fetchHighlights({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('SET_HIGHLIGHT_STATUS', 'pending')
			commit('SET_HIGHLIGHT_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await getHighlights(params)
				commit('SET_HIGHLIGHT_STATUS', 'init')
				commit('SET_HIGHLIGHT_LIST', data)
				return data
			} catch (error) {
				commit('SET_HIGHLIGHT_STATUS', 'init')
				throw error
			}
		},

		async fetchHighlightByID({ commit }, params) {
			commit('SET_HIGHLIGHT_STATUS', 'pending')
			try {
				const { data } = await highlightByID(params)
				commit('SET_HIGHLIGHT_STATUS', 'init')
				commit('SET_HIGHLIGHT_LIST', data.data)
				return data
			} catch (error) {
				commit('SET_HIGHLIGHT_STATUS', 'init')

				return error
			}
		},
		async deleteHighlightRecord({ commit }, params) {
			commit('SET_HIGHLIGHT_STATUS', 'pending')
			try {
				const { data } = await deleteHighlight(params)
				commit('SET_HIGHLIGHT_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_HIGHLIGHT_STATUS', 'error')

				return error
			}
		},

		async saveHighlight({ commit }, params) {
			commit('SET_HIGHLIGHT_STATUS', 'pending')
			try {
				const { data } = await saveHighlight(params)
				commit('SET_HIGHLIGHT_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_HIGHLIGHT_STATUS', 'init')
				throw error
			}
		},
		async updateHighlight({ commit }, params) {
			commit('SET_HIGHLIGHT_STATUS', 'pending')
			try {
				const { data } = await updateHighlight(params)
				commit('SET_HIGHLIGHT_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_HIGHLIGHT_STATUS', 'init')
				throw error
			}
		},
	},
}
